import axios from '@/services/axios'
import qs from 'qs'

export default {
  // 获取模型中心模型列表
  getModelData() {
    const apiConfig = Wiz.globalSettings.dynamicModules?.modules['wiz-iot-management']?.config?.modelListServer || ''
    return axios.get(`${apiConfig}`)
  },
}
